import { getAxiosInstance } from "../http";

import { Till } from "../models/till.model"
import { Assignation } from "../models/assignation.model"

export class TillService {

    static getTills = async (prefix?: string): Promise<Till[]> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/tills' : 'tills'

        const response = await instance.get(url)

        return response.data.map((t: any) => Till.fromJSON(t))
    }

    static createTill = async (till: { name: string, agencyId: number, serviceIds: number[] }, prefix?: string): Promise<Till> => {

        const instance = getAxiosInstance()

        const url = prefix ? prefix + '/tills' : 'tills'

        const payload = { name: till.name, agency_id: till.agencyId, services_id: till.serviceIds }

        const response = await instance.post(url, JSON.stringify(payload))

        return Till.fromJSON(response.data)
    }

    static assignTill = async (tillId: number, userId: number, startDate: string, endDate: string, prefix = 'sup'): Promise<void> => {

        const instance = getAxiosInstance()

        const payload = { till_id: tillId, user_id: userId, start_date: startDate, end_date: endDate }
        
        await instance.post(`${prefix}/assignments`, JSON.stringify(payload))
    }

    static getTillAssignments = async (tillId: number, prefix = 'sup'): Promise<Assignation[]> => {

        const instance = getAxiosInstance()

        const params = { start_date: '2026-01-01', end_date: '2100-12-31' }

        const response = await instance.get(`${prefix}/assignments/till/${tillId}`, {params})

        return response.data.map((a: any) => Assignation.fromJSON(a))
    }
}